import { useState } from "react";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { toast } from "react-toastify";
import { verifyOtpAndSetNewPassword } from "../../redux/actions/auth";
import { useDispatch } from "react-redux";
import { userUpdatePassword } from "../../redux/actions/users";
import { authanticatedUser } from "../../utils/helper";

export default function SetNewPasswordModal ({options}) {
    const dispatch = useDispatch()
  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [retypeNewPassword, setRetypeNewPassword] = useState("");

  const {newPassOpen, setNewPassOpen} = options


  const handleSubmit = (e) => {
    e.preventDefault()
      if(newPassword !== retypeNewPassword) {
        toast.error("Password dosen't match")
        return;
      }
      const tmpInfo = {
        currentPassword: password,
        newPassword,
        token: authanticatedUser.token,
        login : 1
      }
      console.log(tmpInfo)
      dispatch(userUpdatePassword(tmpInfo));
      setNewPassOpen(false);
  }



  return (
    <Dialog
      open={newPassOpen}
      onClose={() => setNewPassOpen(false)}
      className="relative z-50"
    >
      <DialogBackdrop className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />

      <div className="fixed inset-0 z-10 overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
          <DialogPanel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
            <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
              <div className="sm:flex sm:items-start">
                <div className="mt-3 text-center sm:mt-0 sm:text-left w-full">
                  <DialogTitle
                    as="h3"
                    className="text-lg font-bold leading-6 text-primary-dark"
                  >
                    Set New Password
                  </DialogTitle>
                  <div className="mt-4">
                    <form  className="space-y-4">

                    <div>
                        <label
                          htmlFor="password"
                          className="block text-sm font-medium text-gray-700"
                        >
                          Enter Temporary Password
                        </label>
                        <input
                            id="password"
                            name="password"
                            type="password"
                            value={password}
                            autoComplete="password"
                            onChange={e => setPassword(e.target.value)}
                            placeholder="Current password"
                            className="block w-full pl-2 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600  sm:leading-6"
                          />
                      </div>
                      <div>
                        <label
                          htmlFor="newPassword"
                          className="block text-sm font-medium text-gray-700"
                        >
                          New Password
                        </label>
                        <input
                          type="password"
                          id="newPassword"
                          value={newPassword}
                          onChange={(e) => setNewPassword(e.target.value)}
                          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary focus:ring-primary sm:text-sm"
                          required
                        />
                      </div>
                      <div>
                        <label
                          htmlFor="retypeNewPassword"
                          className="block text-sm font-medium text-gray-700"
                        >
                          Confirm Password
                        </label>
                        <input
                          type="password"
                          id="retypeNewPassword"
                          value={retypeNewPassword}
                          onChange={(e) => setRetypeNewPassword(e.target.value)}
                          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary focus:ring-primary sm:text-sm"
                          required
                        />
                      </div>

                      <div>
                        <button
                           onClick={(e) => handleSubmit(e)}
                           type="submit"
                          className="inline-flex w-full justify-center rounded-md border border-transparent bg-primary px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secondary-dark focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 sm:text-sm"
                        >
                          Set New Password
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
}
